module.exports = __webpack_public_path__ + "static/media/opening-activity.801e1e68.md";